import { TableCell, TableRow, Typography } from '@mui/material'
import { OptionUsage } from '@ulysses-inc/harami_api_client'
import date from 'src/exShared/util/date'

export const OptionUsageRow = ({
  optionUsage,
}: {
  optionUsage: OptionUsage
}) => {
  const { period, usage } = optionUsage
  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2">
          {date.formatYYYYMM_JP(new Date(period))}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{usage.toLocaleString()}</Typography>
      </TableCell>
    </TableRow>
  )
}
